import { Link } from "react-router-dom";
import './FlashCard.scss'

export default function FlashCard({title, img, color, age, path}){
    return(
        <div className="FlashCard">
            <div style={{background: color}} className="wrapper">
                <div className="card_body">
                    <div className="title">
                        {title}
                        <div className="age">
                            {age} років
                        </div>
                    </div>
                    

                    <Link to={`/courses/${path}`} aria-label={path}>Детальніше</Link>
                </div>
                <div className="card_img">
                    <img src={img} alt="card icon" />
                </div>
            </div>
        </div>
    )
}